import { getLastArticleInfo } from '@/request/request'

const templateMap = {
    normal_a: {
        contentType: 'sohu',
        clientRender: (cfgs) => {
            window.sohu_mp.article(cfgs)
        },
    },
    abroad_a: {
        contentType: 'sohu',
        clientRender: (cfgs) => {
            window.sohu_mp.article_abroad(cfgs)
        },
    },
    video_a: {
        contentType: 'sohu',
        clientRender: (cfgs) => {
            window.sohu_mp.article_video(cfgs)
        },
    },
    business_a: {
        contentType: 'sohu',
        clientRender: (cfgs) => {
            window.sohu_mp.article_bussiness(cfgs)
        },
    },
    article_na: {
        contentType: 'sohu',
        clientRender: (cfgs) => {
            window.sohu_mp.article_na(cfgs)
        },
    },
    article_focus: {
        contentType: 'focus',
        clientRender: (cfgs) => {
            window.sohu_focus.article_focus(cfgs)
        },
    },
}

export default function (cfgs, type = 'normal_a') {
    const apiParams = templateMap[type]
    const { clientRender, contentType } = apiParams
    const stage = cfgs.stage
    const displayMode = cfgs.displayMode
    console.log('display', typeof displayMode, displayMode)
    const modeConfig = ['normal', '8score', 'login', 'subscription', 'pay']
    if (modeConfig[Number(displayMode)] === '8score') {
        // 请求接口判断是否是作者本人
        const params = {
            stage,
            displayMode
        }
        getLastArticleInfo(params)
            .then((res) => {
                if (res.code === 200) {
                    const content = res?.data?.mpNews?.content
                    cfgs.title = res?.data?.mpNews?.title
                    const articleDom = document.querySelector('.article')
                    const titleDom = document.querySelector('.text-title h1')
                    if(titleDom) {
                        titleDom.innerHTML = cfgs.title
                    }
                    if(articleDom) {
                        articleDom.innerHTML += content
                    }
                    document.title = cfgs.title
                    clientRender(cfgs)
                    const element = document.querySelector('.skeleton-container')// 获取元素
                    if (element && element.parentNode) {
                        element.parentNode.removeChild(element) // 从父元素中移除子元素
                    }
                }
                if (res.code === 404) {
                    window.location.href =
                        contentType === 'focus'
                            ? '//www.focus.cn?pvid=000999_a_404'
                            : '//www.sohu.com?pvid=000999_a_404'
                }
            })
            .catch((err) => {
                console.log('请求剩余内容后初始化客户端JS失败', err)
            })
    }
}
